export default __webpack_public_path__ + "6f3d72c24278c23acf416ec687e89a17.svg";